import { defineStore } from "pinia";
import _ from "lodash";
import {
    PageSizeState,
    PageSizeSelectOption
} from "@/shared/types";
import { getStoragePaths } from "@/shared/storeHelper";

export const initialState: PageSizeState = {
    pageSize: 10
};

const pageSizeSelectOptions: PageSizeSelectOption[] = [
    {
        text: "10",
        value: 10
    },
    {
        text: "50",
        value: 50
    },
    {
        text: "100",
        value: 100
    },
    {
        text: "500",
        value: 500
    }
];

export const usePageSizeStore = defineStore("pageSize", {
    persist: {
        storage: localStorage,
        paths: getStoragePaths("pageSize"),
    },
    state: () => (_.cloneDeep(initialState)),
    getters: {
        pageSizeSelectOptions: () => (totalRecords: number) => {
            if (totalRecords < 10) {
                return null;
            }

            const filteredPageSizeOptions = _.filter(pageSizeSelectOptions, x => {
                return x.value <= totalRecords;
            });

            return [ ...filteredPageSizeOptions ];

        }
    },
    actions: {
        setPageSize (pageSize: number) {
            this.pageSize = pageSize;
        }
    }
});
